<template>
  <div id="pricingCenter">
    <!-- 搜索 -->
    <div class="flex justify-end align-center" style="height: 32px;">
      <el-input @input='clearSear' @change='searchDev' style="width: 320px;" placeholder="请输入设备码" v-model="search" class="input-with-select">
      </el-input>
      <i @click="searchDev" style="position: absolute; right: 50px; top: 32px;color: #000000;font-size: 16px;cursor: pointer;" class="el-icon-search"></i>
    </div>
    <!-- 分界线 -->
    <div class="" style="height: 10px;background-color: #F5F6FA;width: 100%;margin-top: 16px;margin-bottom: 24px;">

    </div>

    <div class="flex flex-direction justify-between" style="min-height: 780px;">
      <div class="">
        <!-- 表格 -->
        <el-table :data="tableData" stripe style="width: 100%">
          <el-table-column type="index" align="center" label="序号" width="80">
          </el-table-column>
          <el-table-column prop="ip" align="center" label="使用IP">
          </el-table-column>
          <el-table-column prop="dev" align="center" label="设备码">
          </el-table-column>
          <el-table-column prop="data" align="center" width='340' label="算价数据">
            <template slot-scope="scope">
              <el-button @click='showSj(scope.row.data)' type="text" size="small">
                查看
              </el-button>
            </template>
          </el-table-column>
          <el-table-column prop="create_time" align="center" label="算价时间">
          </el-table-column>
          <el-table-column prop="version_number" align="center" label="计算使用版本">
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页 -->
      <el-pagination id='pagebox' style="margin-top: 30px;text-align: center;" background
        @current-change="handleCurrentChange" :current-page="tablePage" :page-size='tableLimit' :page-sizes="[100, 200, 300, 400]"
        layout="total, prev, pager, next, jumper" :total="tableCount">
      </el-pagination>
    </div>


  <!-- 算价数据展示 -->
  <el-dialog
    title="算价数据"
    :visible.sync="dialogVisible"
    width="40%"
    id="sjsj"
    >
    <div class="" style="height: 350px;overflow-y: auto;">
      <p style="text-align: left;padding: 2px 0;" v-for="(item,index) in files" :key="index"><span style="font-weight: 700;">{{index<=8?'0'+(index+1):index+1}}</span>. {{item}}</p>
    </div>
    <div class="flex justify-end" style="margin-top: 20px;">
      {{price}}
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button style="height: 32px;padding: 9px 20px;background-color: #1BADE8;color: #FFFFFF;" type="primary" @click="dialogVisible = false">确 定</el-button>
    </span>
  </el-dialog>

  </div>

</template>

<script>
  export default {
    name: 'pricingCenter',
    created() {
      this.getTable()
    },
    data() {
      return {
        search: '',
        dialogVisible:false,
        price:'',
        files:[],
        /* 获取表格数据发送参数 */
        sendData: {
          act: 'userPrice',
          page: 1,
          limit: 15
        },
        /* 渲染页面参数 */
        tablePage: 1, //表格--当前页
        tableLimit: 10, //表格--当前页数据条数尺寸
        tableCount: 10, //表格--数据总条数
        tableData: [], //表格--数据列表
      }

    },
    methods: {
      /******************* 获取数据列表 */
      getTable() {
        this.$api.dataList.userTable(this.sendData).then(res => {
          // console.log(res)
          if (res.code == '1') {
            this.tablePage = res.data.page
            this.tableLimit = res.data.limit
            this.tableCount = res.data.count
            this.tableData = res.data.list
          }
        })
      },
      /******************* 切换页面  */
      handleCurrentChange(val) {
        // console.log(`当前页: ${val}`);
        this.sendData.page = val
        this.getTable()
      },
      /* 搜索 */
      searchDev(){
        if(!this.search) return false
        this.$api.dataList.userTable({
          act:'userPrice',
          dev:this.search
        }).then(res=>{
          // console.log('搜索：',res)
          if(res.code='1'){
            this.tablePage=res.data.page
            this.tableLimit=res.data.limit
            this.tableCount=res.data.count
            this.tableData=res.data.list
          }else{
            this.$message({
              message: res.info,
              type: 'error'
            })
          }
        })
      },
      clearSear(e){
        // console.log(e)
        if(e!='') return false
        this.sendData.page=1
        this.getTable()
      },

      /* 展示算价 */
      showSj(_json){
        this.dialogVisible=true
        console.log(JSON.parse(_json))
        this.price=JSON.parse(_json).price
        this.files=JSON.parse(_json).files
      }
    }
  }
</script>

<style>
  #pricingCenter {
    background-color: #FFFFFF;
    padding: 24px;
    position: relative;
    border-radius: 6px;
  }

  #pricingCenter #pagebox {

  }

  /****************************/
  /* 算价数据弹框 */
  #sjsj .el-dialog{
    padding: 20px;
    border-radius: 8px;
  }
  #sjsj .el-dialog__header{
    padding: 0;
    border-bottom: 1px solid #F5F6F7;
    padding-bottom: 16px;
    text-align: left;
  }
  .el-dialog__title{
    font-size: 14px;
    font-weight: 700;

  }
  #sjsj .el-dialog__body{
    padding: 0;
    margin-bottom: 24px;
    margin-top: 24px;
    border: 1px solid #CCCCCC;
    border-radius: 6px;
    padding: 6px;
  }
  #sjsj .el-dialog__footer{
    padding: 0;
  }

</style>



// WEBPACK FOOTER //
// src/components/pricingCenter.vue